import { toast } from "react-toastify";
import { _AdquisitionContractRP, _RecordBudget, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { BasicTable, MASK_DATE, MASK_NUMBER } from "../../../../theme/Component/BasicTable";
import { useEffect, useState } from "react";
import { Modal } from "../../../../theme/Component/Modal";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { InputDate } from "../../../../theme/Input/InputDate";
import { DocumentHeaderEditor } from "../../../../contabilidad/bodegaDocumentos/DocumentHeaderEditor";
import { DocumentViewer } from "../../../../theme/Component/DocumentViewer";
import { ErrorList } from "../../../../theme/Component/ErrorList";

interface Props {
    adquisitionContract: any;
}

export const AdquisitionContractRP = ({ adquisitionContract }: Props) => {

    const { lista, setLista, instance, bean, setBean } = useDataBean(_RecordBudget);

    const [chargeDate, setChargeDate] = useState<any>(_single.getCurrenDate());

    const [documents, setDocuments] = useState<any>([]);
    const [msgList, setMsgList] = useState<any>([]);

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar Item", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modalView, setModalView] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });


    useEffect(() => {
        if (adquisitionContract.IDAdquisitionContract) {
            getLista();
        }
    }, [adquisitionContract])

    const getLista = () => {
        instance.getBudgetRecordForAdquisitionContract(adquisitionContract.IDAdquisitionContract, adquisitionContract.AdquisitionContractDate, chargeDate).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
    }

    const createCDP = () => {
        setBean({
            IDAdquisitionContract: adquisitionContract.IDAdquisitionContract,
            AdquisitionContractDate: adquisitionContract.AdquisitionContractDate,
        });
        setModal({ ...modal, "view": true, "name": "CDP" });
    }

    const updateItem = () => {
        instance.setAdquisitionContractToRP(bean.IDAdquisitionContract, bean.AdquisitionContractDate, bean.IDDocument, bean.DocumentDate, _single.getAccountID(), true).then(
            (resp) => {
                setModal({ ...modal, "view": false });
                setDocuments(resp.DocumentURL);
                setMsgList(resp.MsgList);
                setModalView({ ...modalView, "view": true, "name": "Documento Generado" });
                getLista();
            }
        ).catch(err => { toast.error(err) })
    }

    const deleteObject = () => {
        instance.releaseRecordBudgetFromAdquisitionContract(bean.IDDocument, bean.DocumentDate, _single.getAccountID()).then(
            (resp) => {
                getLista()
                setModalC({ ...modalC, "view": false });
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDDocument', visible: true, mask: MASK_NUMBER },
        { title: 'Fecha', property: 'DocumentDate', visible: true, mask: MASK_DATE },
        { title: 'Mnemonic', property: 'Mnemonic', visible: true },
        { title: 'Consecutivo', property: 'Consecutive', visible: true },
        { title: 'Consecutivo Ext', property: 'ExternalReference', visible: true },
        { title: 'Estado del Documento', property: 'DocumentStateName', visible: true },
    ]


    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: () => { createCDP() } }
    ]

    const listaBotones = () => {
        const botones = [
            // { titulo: 'Eliminar', icono: 'ri-file-user-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true, "name": "Eliminar Item" }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <div className="row">
            {/* <PrintJson json={adquisitionContract} /> */}
            <div className="col-md-6">
                <InputDate name="" value={chargeDate} setDate={(e) => { setChargeDate(e) }} label="Fecha Actual" />
            </div>
            <div className="col-md-12">
                <BasicTable iconButtons={iconButtonsItem} listButtons={listaBotones()} body={lista} head={head} rowSet={setBean} />
            </div>
            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={updateItem}>
                    <div className="row">
                        <div className="col-md-12">
                            <DocumentHeaderEditor label="RP Seleccionado" onChange={(e) => { setBean({ ...bean, "IDDocument": e.IDDocument, "DocumentDate": e.Since, "DocumentState": e.DocumentState, "Consecutive": e.Consecutive, "Mnemonic": e.Mnemonic, }) }} />
                        </div>
                    </div>
                </Modal>
            </div>
            <div className="col-md-12">
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteObject}>
                    <p>Esta seguro que desea eliminar el item {`${bean.Mnemonic} - ${bean.Consecutive}`}</p>
                </ModalConfirm>
            </div>
            <div className="col-md-12">
                <Modal modal={modalView} updateModal={setModalView}>
                    {msgList.length > 0 &&
                        <ErrorList lista={msgList} />
                    }
                    {msgList.length === 0 && documents.length > 0 &&
                        <DocumentViewer key={documents} list={documents} />
                    }
                </Modal>
            </div>
        </div>
    )

}